<!-- Output for widget, page -->
<div class="widget {{ step }}">

	<step-index [wrapperClass]="'step-index-ti'" [steps]="{'contribution': [], 'personal-data': [], 'payment': ['payment_select'], 'thankyou': []}" [(step)]="step" [donation]="donation" [donationAmountStartStep]="'payment'" (stepChange)="stepChange($event)"></step-index>
	<fullscreentext [step]="step"></fullscreentext>

	<!-- contact data -->
	<form [action]="" method="POST" (submit)="submitForm()" [formGroup]="contactForm" *ngIf="step == 'personal-data'" novalidate>
		<div class="row column">
			<h1>{{ 'ti.personal-data.headline' | translate }}</h1>
		</div>

		<ti-personaldata [form]="contactForm" [contact]="contact"></ti-personaldata>

		<!-- Button -->
		<div class="row columns">
			<submit [text]="'ti.personal-data.button' | translate" [arrow]="true" [additionalClasses]="'hollow'"></submit>
		</div>
	</form>
	<!-- /contact data -->

	<!-- contribution and checkboxes -->
	<form [action]="" method="POST" (submit)="submitForm()" [formGroup]="widgetStartForm" *ngIf="step == 'contribution'" novalidate>
		<div class="row column">
			<h1>{{ 'ti.contribution.headline' | translate }}</h1>
		</div>

		<div class="row contribution-selection">
			<div class="columns small-4">
				<radio [(model)]="contributionValue" [value]="'normal'" [name]="'contributionValue'" [label]="'ti.contribution.value.normal' | translate" [required]="true" (click)="setAmount(120)" [form]="widgetStartForm"></radio>
			</div>
			<div class="columns small-4">
				<radio [(model)]="contributionValue" [value]="'reduced'" [name]="'contributionValue'" [label]="'ti.contribution.value.reduced' | translate" [required]="true" (click)="setAmount(36)" [form]="widgetStartForm"></radio>
			</div>
			<div class="columns small-4">
				<radio [(model)]="contributionValue" [value]="'manual'" [name]="'contributionValue'" [label]="'ti.contribution.value.manual' | translate" [required]="true" (click)="setAmount(120)" [form]="widgetStartForm"></radio>
			</div>
		</div>

		<div class="row column" *ngIf="contributionValue == 'reduced'">
			<p class="static-infotext"><i class="twingle-info"></i><span [innerHtml]="'ti.contribution.info' | translate"></span></p>
		</div>

		<!-- input / slider -->
		<amount [donation]="donation" [form]="widgetStartForm" *ngIf="contributionValue == 'manual'"></amount>
		<amount-extra [donation]="donation" [form]="widgetStartForm" [amount]="donation.amount" *ngIf="contributionValue == 'manual'"></amount-extra>		

		<!-- Button -->
		<div class="row columns">
			<submit [text]="'ti.contribution.button' | translate" [arrow]="true" [additionalClasses]="'hollow'"></submit>
		</div>
	</form>
	<!-- /contribution and checkboxes -->

	<!-- payment -->
	<form onsubmit="document.getElementById('value2').value.length > 0? this.submit() : false" [target]="paymentFormTarget" method="POST" (ngSubmit)="submitForm()" [formGroup]="widgetPaymentForm" *ngIf="step == 'payment'" novalidate>
		<div class="row column">
			<h1>{{ 'ti.payment.headline' | translate }}</h1>
		</div>

		<!-- Status -->
		<donation-status [status]="donationStatus" [message]="donationStatusMessage" [donation]="donation" (statusChange)="onStatusChange($event)"></donation-status>

		<!-- payment -->
		<payment [donation]="donation" [amount]="donation.amount" [rythm]="donation.rythm" [contact]="contact" [form]="widgetPaymentForm" [(donationStatus)]="donationStatus" [size]=size [(step)]="step" [version]="version" (stepChange)="stepChange($event)"></payment>

		<!-- donation data for sending the data to an external form -->
		<hidden-formsubmit [id]="'value2'" [donation]="donation" [contact]="contact" [type]="version" [step]="step" [size]="size" [form]="widgetPaymentForm"></hidden-formsubmit>

		<!-- Button -->
		<div class="row columns" *ngIf="step == 'payment'">
			<div id="expresscheckout"></div>
			<submit [text]="'ti.payment.button' | translate: {amount: donation.amount}" [arrow]="false" [secureText]="'payment.submit.hint' | translate"></submit>
		</div>

		<div class="back-wrapper">
			<a (click)="stepBack()">{{ "ti.general.back" | translate }}</a>
		</div>
	</form>
	<!-- /payment -->

	<!-- iframe, status -->
	<donation-status [status]="donationStatus" [donation]="donation" [message]="donationStatusMessage" (statusChange)="onStatusChange($event)" *ngIf="step == 'iframe' || step == 'contact-mandatory-finished'"></donation-status>
	<payment-iframe [donation]="donation" *ngIf="step == 'iframe'" [buttonPlaceholders]="getSubmitButtonPlaceholders()"  [projectType]="projectType"></payment-iframe>

	<!-- step: thank you -->
	<thankyou-order [step]="step" [projectType]="projectType" [donation]="donation" [contact]="contact" [form]="contactForm" [size]="size" [version]="version" (stepChange)="stepChange($event, true)"></thankyou-order>
</div>


<footer>
	<div class="row column">
		<span>{{ 'footer.service' | translate }}</span>
		<a href="https://www.gls.de/" target="_blank"><img src="/bundles/twinglepublic/donation-app/img/logo-gls.svg" alt="GLS"></a>
	</div>
</footer>

<tracking></tracking>
